import React from 'react';
import AddNewListingIcon from './add-new-listing';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function AddPropertyIcon(props) {
  return ___EmotionJSX(AddNewListingIcon, props);
}